import React, { useCallback, useEffect, useMemo, useState } from "react";
import { DeleteOutlined, PlusOutlined, TagsOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { Button, Popconfirm, Spin, Table, Tag, message } from "antd";
import { deleteSprCardVid, fetchSprCardVids } from "./spr-cards-api";
import SprCardVidDrawer from "./spr-card-vid-drawer";
import { cardColorCss } from "@core/card-keys";
import { getLawFlag } from "../status/spr-status-utils";
import "./spr-cards.css";

const SprCardVids = () => {
  const law = useSelector((state) => state.user.session?.law);
  const canEdit = getLawFlag(law, 46) === 1;

  const [messageApi, contextHolder] = message.useMessage();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchSprCardVids();
      setItems(Array.isArray(data) ? data : []);
    } catch {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const remove = async (vid) => {
    try {
      await deleteSprCardVid(vid);
      messageApi.success("Удалено");
      load();
    } catch (e) {
      messageApi.error(e?.message || "Не удалось удалить");
    }
  };

  const columns = useMemo(() => [
    {
      title: "Тип",
      render: (_, r) => {
        const css = cardColorCss(r.color);
        return (
          <span className="spr-cards-vid">
            <span className="spr-cards-vid-dot" style={{ background: css || "#fff" }} />
            {r.name}
          </span>
        );
      }
    },
    { title: "На выходе", width: 120, render: (_, r) => (Number(r.isGetOnExit) === 1 ? <Tag>да</Tag> : "—") },
    { title: "Долговая", width: 120, render: (_, r) => (Number(r.isCardDolg) === 1 ? <Tag>да</Tag> : "—") },
    {
      title: "",
      width: 40,
      render: (_, r) => canEdit && (
        <Popconfirm title="Удалить тип?" onConfirm={() => remove(r.vid)}>
          <Button type="text" size="small" danger icon={<DeleteOutlined />} onClick={(e) => e.stopPropagation()} />
        </Popconfirm>
      )
    }
  ], [canEdit]);

  return (
    <div className="spr-cards-page">
      {contextHolder}
      <div className="spr-cards-toolbar">
        <div className="spr-cards-title">
          <TagsOutlined />
          <span>Типы карт</span>
        </div>
        <div className="spr-cards-spacer" />
        {canEdit ? (
          <Button type="primary" icon={<PlusOutlined />} onClick={() => { setEdit(null); setDrawerOpen(true); }}>
            Добавить
          </Button>
        ) : null}
      </div>
      <div className="spr-cards-body">
        <Spin spinning={loading}>
          <Table
            rowKey="vid"
            size="middle"
            columns={columns}
            dataSource={items}
            pagination={false}
            locale={{ emptyText: "Типов карт нет" }}
            onRow={(record) => ({
              className: "spr-cards-row",
              onClick: () => { setEdit(record); setDrawerOpen(true); }
            })}
          />
        </Spin>
      </div>
      <SprCardVidDrawer
        vid={edit}
        open={drawerOpen}
        canEdit={canEdit}
        onClose={() => setDrawerOpen(false)}
        onSaved={load}
      />
    </div>
  );
};

export default SprCardVids;
